import { Command, Key } from './types';

export const keyboard: Array<Key> = [
  {
    value: 'á',
  },
  {
    value: 'à',
  },
  {
    value: 'â',
  },
  {
    value: 'ä',
  },
  {
    value: 'ă',
  },
  {
    value: 'ā',
  },
  {
    value: 'ã',
  },
  {
    value: 'å',
  },
  {
    value: 'ą',
  },
  {
    value: 'æ',
  },
  {
    value: 'ć',
  },
  {
    value: 'ċ',
  },
  {
    value: 'ĉ',
  },
  {
    value: 'č',
  },
  {
    value: 'ç',
  },
  {
    value: 'ď',
  },
  {
    value: 'đ',
  },
  {
    value: 'Đ',
  },
  {
    value: 'é',
  },
  {
    value: 'è',
  },
  {
    value: 'ė',
  },
  {
    value: 'ê',
  },
  {
    value: 'ë',
  },
  {
    value: 'ě',
  },
  {
    value: 'ĕ',
  },
  {
    value: 'ē',
  },
  {
    value: 'ę',
  },
  {
    value: 'ġ',
  },
  {
    value: 'ĝ',
  },
  {
    value: 'ğ',
  },
  {
    value: 'ģ',
  },
  {
    value: 'ĥ',
  },
  {
    value: 'ħ',
  },
  {
    value: 'i',
  },
  {
    value: 'ı',
  },
  {
    value: 'í',
  },
  {
    value: 'ì',
  },
  {
    value: 'î',
  },
  {
    value: 'ï',
  },
  {
    value: 'ĭ',
  },
  {
    value: 'ī',
  },
  {
    value: 'ĩ',
  },
  {
    value: 'į',
  },
  {
    value: 'ĳ',
  },
  {
    value: 'ĵ',
  },
  {
    value: 'ķ',
  },
  {
    value: 'ĺ',
  },
  {
    value: 'ŀ',
  },
  {
    value: 'ľ',
  },
  {
    value: 'ļ',
  },
  {
    value: 'ł',
  },
  {
    value: 'ń',
  },
  {
    value: 'ň',
  },
  {
    value: 'ñ',
  },
  {
    value: 'ņ',
  },
  {
    value: 'ŋ',
  },
  {
    value: 'ó',
  },
  {
    value: 'ò',
  },
  {
    value: 'ô',
  },
  {
    value: 'ð',
  },
  {
    value: 'õ',
  },
  {
    value: 'ö',
  },
  {
    value: 'ŏ',
  },
  {
    value: 'ō',
  },
  {
    value: 'õ',
  },
  {
    value: 'ő',
  },
  {
    value: 'œ',
  },
  {
    value: 'o',
  },
  {
    value: 'ŕ',
  },
  {
    value: 'ř',
  },
  {
    value: 'ŗ',
  },
  {
    value: 'ś',
  },
  {
    value: 'ŝ',
  },
  {
    value: 'š',
  },
  {
    value: 'ş',
  },
  {
    value: 'ť',
  },
  {
    value: 'ţ',
  },
  {
    value: 'Þ',
  },
  {
    value: 'þ',
  },
  {
    value: 'ŧ',
  },
  {
    value: 'ú',
  },
  {
    value: 'ù',
  },
  {
    value: 'û',
  },
  {
    value: 'ü',
  },
  {
    value: 'ŭ',
  },
  {
    value: 'Shift',
    command: Command.Uppercase,
    width: '5.5rem',
  },
  {
    value: 'ū',
  },
  {
    value: 'ũ',
  },
  {
    value: 'ů',
  },
  {
    value: 'ų',
  },
  {
    value: 'ű',
  },
  {
    value: 'ŵ',
  },
  {
    value: 'ý',
  },
  {
    value: 'ŷ',
  },
  {
    value: 'ÿ',
  },
  {
    value: 'ź',
  },
  {
    value: 'ż',
  },
  {
    value: 'ž',
  },
  {
    value: 'ž',
  },
  {
    value: 'Chiudi',
    command: Command.Close,
    width: '5.5rem',
  },
];
